const WEBHOOK_LOGS_INDEX = 'webhook-logs';

interface BuildListSearchBodyParams {
    webhookId: string;
    page: number;
    pageSize: number;
    createdAt?: string | null;
    failedOnly?: boolean;
}

const buildCreatedAtRangeFilter = (createdAt?: string | null) => {
    if (!createdAt) return undefined;

    const [from, to] = createdAt.split(',');
    if (!from) return undefined;

    const range: Record<string, string> = {
        gte: from,
    };
    if (to) {
        range.lte = to;
    }

    return {
        range: {
            createdAt: range,
        },
    };
};

export const buildWebhookLogsSearchPath = (agentId: string) => (
    `/v1/agents/${agentId}/search/${WEBHOOK_LOGS_INDEX}`
);

export const buildWebhookLogsListSearchBody = ({
    webhookId,
    page,
    pageSize,
    createdAt,
    failedOnly = false,
}: BuildListSearchBodyParams) => {
    const filter: Array<Record<string, unknown>> = [
        { term: { webhookId } },
    ];

    const createdAtFilter = buildCreatedAtRangeFilter(createdAt);
    if (createdAtFilter) {
        filter.push(createdAtFilter);
    }

    if (failedOnly) {
        filter.push({ term: { status: 'error' } });
    }

    return {
        query: {
            bool: {
                filter,
            },
        },
        sort: [{ createdAt: 'desc' }],
        from: Math.max(0, (page - 1) * pageSize),
        size: pageSize,
    };
};

export const buildWebhookLogByIdSearchBody = ({
    logId,
    webhookId,
}: {
    logId: string;
    webhookId?: string;
}) => {
    const filter: Array<Record<string, unknown>> = [
        { ids: { values: [logId] } },
    ];

    if (webhookId) {
        filter.push({ term: { webhookId } });
    }

    return {
        query: {
            bool: {
                filter,
            },
        },
        size: 1,
    };
};
